module.exports = __webpack_public_path__ + "static/media/Thumbnail-yuma-part-two.69857d13.png";